import React, {useEffect, useState} from "react";
import classes from "./styles.module.css";
import {Column, Container, Wrapper} from "../../../hoc/Layout";
import EmptyCard from "../../../hoc/EmptyCard";
import Button from "../../../Components/Utils/UI/Button";
import {NavLink} from "react-router-dom";
import PcaTable from "../../../Components/PcaTable";
import {MultipleSelect} from "../../../Components/Utils/FieldsHelper";
import DateRange from "../../../Components/Utils/DateRange";
import Api from "../../../Api";
import Pagination from "react-js-pagination";
import PcaFilters from "../../../Components/PcaFilters";
import { withAuth } from "../../../hoc/Auth";
import { useLocation } from "react-router-dom";

function PcaList({token}) {
    const { search } = useLocation()
    const searchParams = new URLSearchParams(search)
    const psaContractId = searchParams.get('psaContractId')

    const [requestFilters, setRequestFilters] = useState({
        psaContracts: psaContractId ? [psaContractId] : []
    })

    const [contracts, setContracts] = useState([])
    const [contractsList, setContractsList] = useState([])
    const [terminals, setTerminals] = useState([])

    const [isContactsListLoading, setIsContractsListLoading] = useState(true)
    const [isLoadingContracts, setIsLoadingContracts] = useState(true);
    
    const [defaultPeriod] = useState('week');
    const [filterDate, setFilterDate] = useState({});
    const [filteredContracts, setFilteredContracts] = useState([])
    const [filteredStatuses, setFilteredStatuses] = useState({})

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const handleStatusFilter = (data) => {
        Object.entries(data).forEach(([k, v]) => {
            setFilteredStatuses({...filteredStatuses, [k]: v})
        })
    }

    useEffect(() => {
        new Api({token}).getProjects().then((data) => {
            const providers = []
            data.map(p => p.providers.map(t => providers.push(t)))
            setTerminals(providers)
        })
    }, [])

    useEffect(() => {
        new Api({token}).getMetalContracts().then((data) => {
            setContracts(data.data ? data.data.map(i => ({
                ...i, 
                // MultipleSelect Support
                displayName: i.name,
                uuid: i.id
            })) : [])
            setIsLoadingContracts(false)
            if (psaContractId) {
                setFilteredContracts([Number(psaContractId)])
            }
        })

        new Api({token}).getPsaItems({
            page: currentPage,
            itemsPerPage: itemsPerPage,
            ...requestFilters
        }).then((data) => {
            setContractsList(data.data)
            setIsContractsListLoading(false)
        })
    }, []);

    function setPage(page, itemsPerPage) {
        if (page)
            setCurrentPage(page);
        else
            setCurrentPage(1);

        if (itemsPerPage)
            setItemsPerPage(itemsPerPage)

        new Api({token}).getPsaItems({
            page: currentPage,
            itemsPerPage: itemsPerPage,
            ...requestFilters
        }).then((data) => {
            setContractsList(data.data)
        })
    }

    function applyFilters() {
        setIsContractsListLoading(true);

        const filters = {
            psaContracts: filteredContracts.length 
                                ? filteredContracts 
                                : undefined,
            'dateRange{}': filterDate,
            statuses: Object.entries(filteredStatuses).length 
                            ? Object.entries(filteredStatuses).filter(([_, v]) => v).map(([k]) => k)
                            : undefined
        }
        setRequestFilters(filters)
        new Api({token}).getPsaItems({
            page: currentPage,
            itemsPerPage: itemsPerPage,
            ...filters,
        }).then((data) => {
            setContractsList(data.data)
        }).finally(() => {
            setIsContractsListLoading(false);
        })
    }

    return (
        <Wrapper>
            <Container className={classes.StackOnMobile}>
                <Column width="780" className={classes.MainColumn}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>Список ПСА</h5>
                        </div>

                        <div className={classes.TableWrap}>
                            <PcaTable terminals={terminals} contracts={contracts} contractsList={contractsList}
                                      isLoading={isContactsListLoading}/>
                        </div>

                        <div className={classes.PaginationWrap}>
                            <Pagination
                                firstPageText="⇤"
                                prevPageText="⇠"
                                lastPageText="⇥"
                                nextPageText="⇢"
                                activeLinkClass={classes.ActiveLink}
                                activePage={currentPage}
                                itemsCountPerPage={itemsPerPage}
                                totalItemsCount={2}
                                pageRangeDisplayed={10}
                                onChange={(page) => setPage(page, itemsPerPage)}
                            />
                        </div>
                    </div>
                </Column>

                <Column width="350" className={classes.SideColumn}>
                    <EmptyCard>
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal/contract/create`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.contractCreate"}
                                        icon={"share"}
                                        color={"#3cc23a"}
                                    />
                                </NavLink>
                            </li>

                            <li className={classes.MenuItem}>
                                <NavLink
                                    to={`/metal`}>
                                    <Button
                                        onClick={null}
                                        isLoading={false}
                                        label={"FieldsHelper.label.contractsList"}
                                        icon={"share"}
                                        color={"#474545"}
                                    />
                                </NavLink>
                            </li>
                        </ul>
                    </EmptyCard>
                    <EmptyCard>
                        <MultipleSelect
                            label={"FieldsHelper.label.contract"}
                            placeholder={"FieldsHelper.label.contract"}
                            values={contracts}
                            selectedValues={filteredContracts}
                            isLoading={isLoadingContracts}
                            onChange={(data) => setFilteredContracts(data)}
                            excludeSearchColumn={[]}
                        />
                    </EmptyCard>

                    <EmptyCard>
                        <DateRange onSelectDate={(range) => setFilterDate(range)} defaultPeriod={defaultPeriod}/>
                    </EmptyCard>

                    <PcaFilters
                        onSelectFilter={handleStatusFilter}
                    />
                    <EmptyCard>
                        <Button onClick={applyFilters} label="TransactionsFilters.btn.setFilters" icon="filter"
                                iconSize={'17px'} isLoading={isContactsListLoading}/>
                    </EmptyCard>
                </Column>
            </Container>
        </Wrapper>
    )
}

export default withAuth(PcaList);



// WEBPACK FOOTER //
// ./src/PagesOfUser/Metal/PcaList/index.js